export function formatAssignmentName(firstName, lastName) {
  return `${firstName || ""} ${lastName || ""}`.trim();
}

export function formatAssignmentFte(fte) {
  if (fte == null || fte === "") return "1.0 FTE";
  const n = Number(fte);
  if (!Number.isFinite(n)) return "1.0 FTE";
  return `${n.toFixed(1)} FTE`;
}
